// extracted by mini-css-extract-plugin
module.exports = {"container":"Wishlist_container__1p6g_","cardWarper":"Wishlist_cardWarper__2z4uy"};